import request from '@/middleware/request'

const getVersion = () => {
  return request({
    url: '/version',
    method: 'get'
  })
}

export default {
  getVersion
}
